// extracted by mini-css-extract-plugin
export default {"root":"IconShoppingCart_root__caltV"};